import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, IconButton } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeLevelEmployeeListItemComponent = ({ item, index, dispatch, employees, onDelete, validation }) => {
  const { t } = useTranslation();
  const onHeaderPropertyChanged = (propertyName, value) => {
    dispatch({ type: 'OnHeaderPropertyChanged', propertyName, value });
  };

  const setDefaultEmployee = propertyValue => {
    dispatch({ type: 'setDefaultEmployee', propertyValue, index });
    onHeaderPropertyChanged('defaultEmployeeName', propertyValue ? employees.find(x=>x.id===item.employeeId).name : ' ');
  };

  const onPropertyChanged = (propertyName, propertyValue, isDefault, collection = null) => {
    dispatch({ type: 'onPropertyChanged', propertyName, propertyValue, collection, index });
    if (isDefault) onHeaderPropertyChanged('defaultEmployeeName', propertyValue);
  };

  return (
    <TableRow>
      <TableCell>
        <Autocomplete
          fullWidth
          isClearable={false}
          simpleValue
          value={item.employeeId}
          options={employees}
          onChange={event => {
            onPropertyChanged('employeeId', event !== null ? event : null, item.isDefault, 'approvalTypeEmployees');
            onPropertyChanged('employeeName', event !== null ? employees.find(x=>x.id===event).name  : null, item.isDefault, 'approvalTypeEmployees');
          }}
          label={t('ApprovalTypes.ApprovalTypeLevelEmployee.Employee')}
          error={!isValid(validation.employeeId)}
          helperText={getErrors(validation.employeeId)}
          isSearchable={true}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={
            <Checkbox checked={Boolean(item.isDefault)} onChange={event => setDefaultEmployee(event.target.checked)} color='primary' />
          }
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Delete')}
          onClick={() => onDelete('approvalTypeEmployees', item.approvalTypeEmployeeId, index)}
        />
      </TableCell>
    </TableRow>
  );
};

ApprovalTypeLevelEmployeeListItemComponent.propTypes = {
  item: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ApprovalTypeLevelEmployeeListItemComponent;
